var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyEmployee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 133,
    viewBox: "0 0 134 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 39.6779C100.165 39.6226 99.7745 39.6226 99.4395 39.6779C91.7345 39.401 85.5928 33.1389 85.5928 25.3805C85.5928 17.4559 92.0135 11.083 99.9978 11.083C107.982 11.083 114.403 17.5114 114.403 25.3805C114.347 33.1389 108.205 39.401 100.5 39.6779Z",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7486 80.0223C102.398 81.297 110.829 79.9667 116.747 76.0323C124.619 70.823 124.619 62.2889 116.747 57.0798C110.773 53.1451 102.23 51.8151 94.5811 53.1451",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3322 39.6779C33.6672 39.6226 34.0579 39.6226 34.3929 39.6779C42.0979 39.401 48.2397 33.1389 48.2397 25.3805C48.2397 17.4559 41.8189 11.083 33.8347 11.083C25.8505 11.083 19.4297 17.5114 19.4297 25.3805C19.4855 33.1389 25.6272 39.401 33.3322 39.6779Z",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0833 80.0213C31.4343 81.2957 23.0034 79.9657 17.085 76.0313C9.21254 70.822 9.21254 62.2879 17.085 57.0788C23.0592 53.1442 31.6018 51.8141 39.2508 53.1441",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0003 81.0745C66.6653 81.0192 66.2743 81.0192 65.9393 81.0745C58.2343 80.7976 52.0928 74.5354 52.0928 66.777C52.0928 58.8526 58.5135 52.4795 66.4978 52.4795C74.4818 52.4795 80.9028 58.9079 80.9028 66.777C80.8468 74.5354 74.7053 80.8529 67.0003 81.0745Z",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.754 98.5306C42.8815 103.74 42.8815 112.274 50.754 117.483C59.6872 123.413 74.3155 123.413 83.2487 117.483C91.1212 112.274 91.1212 103.74 83.2487 98.5306C74.3712 92.6565 59.6872 92.6565 50.754 98.5306Z",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEmployee);
export default __webpack_public_path__ + "static/media/empty-employee.6106568b.svg";
export { ForwardRef as ReactComponent };